<div class="grid grid-custom-columns gap-0 tk-grid-rows place-items-center h-screen tk-bg-gray-1 tk-i-background">

  <div [formGroup]="form" class="col-start-2 flex-1 flex-col place-items-center w-80">

    <div class="mb-3 grid place-items-center">
      <div class="i-black-marker"></div>
    </div>

    <div class="text-lg font-semibold text-center">{{'create-account.header' | translate}}</div>

    <div class="mt-8 tk-c-gray text-xs text-center">
      {{'create-account.how-to-create' | translate}}
    </div>

    <div *ngIf="showAccountDataError" id="account-data-error" class="mt-6 flex items-center tk-bg-error h-10 rounded-lg">
      <span class="i-red-exclamation ml-2"></span>
      <span class="tk-c-red text-xs ml-2 opacity-100">{{'create-account.error-incorrect-account-data' | translate}}</span>
    </div>

    <mat-form-field class="mt-4" hideRequiredMarker>
      <mat-label>{{'create-account.id' | translate}}</mat-label>
      <input matInput formControlName="id" maxlength="50">
      <mat-error id="id-error-required" *ngIf="idCtrl.hasError('required')">
        {{'errors.field-is-required' | translate}}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="mt-2" hideRequiredMarker>
      <mat-label>{{'create-account.login' | translate}}</mat-label>
      <input matInput formControlName="login" maxlength="50">
      <mat-error id="login-error-required" *ngIf="loginCtrl.hasError('required')">
        {{'errors.field-is-required' | translate}}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="mt-2" hideRequiredMarker>
      <mat-label>{{'fields-names.password' | translate}}</mat-label>
      <input matInput [type]="inputType" maxlength="50" formControlName="password" class="tk-password-spacing">

      <span matSuffix *ngIf="!isRawPasswordVisible && isVisibleShowPasswordButton"
            class="tk-c-blue text-xs tracking-widest" (click)="onShowPasswords()">
        {{'labels.show' | translate | uppercase}}
      </span>

      <span matSuffix *ngIf="isRawPasswordVisible && isVisibleShowPasswordButton" maxlength="50"
            class="tk-c-blue text-xs tracking-widest" (click)="onHidePasswords()">
        {{'labels.hide' | translate | uppercase}}
      </span>

      <mat-error id="password-error-required" *ngIf="passwordCtrl.hasError('required')">
        {{'errors.field-is-required' | translate}}
      </mat-error>
    </mat-form-field>

    <div class="mt-4 tk-c-gray text-xs text-center">{{'create-account.assign-email-info' | translate}}</div>

    <mat-form-field class="mt-4 mb-2" hideRequiredMarker>
      <mat-label>{{'fields-names.email' | translate}}</mat-label>
      <input matInput formControlName="email" maxlength="50">
      <mat-error *ngIf="emailCtrl.invalid" id="{{getErrorMessageElementId('email', emailCtrl)}}">
        {{getErrorMessage(emailCtrl)}}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="mb-9" hideRequiredMarker>
      <mat-label>{{'fields-names.email-repeat' | translate}}</mat-label>
      <input matInput formControlName="emailRepeat" maxlength="50">
      <mat-error *ngIf="emailRepeatCtrl.invalid" id="{{getErrorMessageElementId('emailRepeat', emailRepeatCtrl)}}">
        {{getErrorMessage(emailRepeatCtrl)}}
      </mat-error>
    </mat-form-field>

    <app-button [isLoading]="isLoading" [isFullWidth]="true" [isActive]="!form.pristine" innerTextClasses="my-1.5"
                spinnerClasses="my-3" label="{{'create-account.assign-email' | translate}}" (click)="onSubmit()">
    </app-button>

    <div class="mr-1 text-center mt-4 text-xs">
      {{'create-account.or-login-part1' | translate}}
      <a id="navigate-to-login" class="tk-c-blue cursor-pointer ml-0.5" (click)="onNavigateToLogin()">
        {{'create-account.or-login-part2' | translate}}
      </a>
    </div>
  </div>

  <div class="ml-8 col-start-3 justify-self-start">
    <div class="mt-36 flex flex-col text-xs bg-white p-4 drop-shadow-lg rounded-lg">
      <div class="mb-2 font-semibold">{{'create-account.where-to-find-id' | translate}}</div>
      <div class="tk-c-gray">{{'create-account.desktop-app' | translate}}</div>
      <div class="mb-3 i-desktop-login"></div>
      <div class="tk-c-gray">{{'create-account.mobile-app' | translate}}</div>
      <div class="i-mobile-login"></div>
    </div>
  </div>

  <am-login-footer class="mb-8 w-full col-start-1 col-span-3"></am-login-footer>

</div>

